import React from 'react';
import classNames, { Argument } from 'classnames';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import Language from 'types/LanguageEnum';
import { getSelectedLanguage } from 'modules/translations/selectors';
import { createDictionary } from 'utils/objectUtils';

interface MandatorySymbolProps {
  className?: Argument;
}

const mandatorySymbolMarkStyleByLanguage = createDictionary<Language, string>(
  { [Language.JA_JP]: '!text-xxs kiosk:!text-base' },
  ''
);

const MandatorySymbol: React.FC<MandatorySymbolProps> = ({ className }) => {
  const language = useSelector(getSelectedLanguage);
  return (
    <span
      className={classNames(
        'text-danger-high !text-xl mr-2 kiosk:!text-2xl whitespace-nowrap',
        mandatorySymbolMarkStyleByLanguage[language],
        className
      )}
      aria-hidden="true"
    >
      <FormattedMessage id="mandatorySymbol" defaultMessage="*"/>
    </span>
  );
};

export default MandatorySymbol;
